import React from 'react';
import Widget from 'components/Widget/Widget';
import NetworkQuickReportsData from './components/NetworkQuickReportsData';

const NetworkQuickReports = ({ data, height, configuration, index }) => {
  return (
    <Widget
      className='h-full'
      widget_key={data?.defaultFilter?.network + 'widget' + index}
      title={data.title}
      index={index}
      icon={
        data?.defaultFilter?.network && (
          <img src={`/icons/networks/${data?.defaultFilter?.network}.svg`} className='w-5 h-5 ' />
        )
      }
      configuration={configuration}
      disableLimit
      disableStatusFilter
      disableLevelFilter
      network={data?.defaultFilter?.network}
      networkSwitch={false}
      default_filter={data?.defaultFilter}
      adsFilter
      adsetFilter
      campaignFilter
      showDatePicker
      position={data?.position}
      dashboard_widget_key={data?.key}
    >
      <NetworkQuickReportsData
        height={height}
        data={data}
        network={data?.defaultFilter?.network}
        widget_key={data?.defaultFilter?.network + 'widget' + index}
      />
    </Widget>
  );
};

export default NetworkQuickReports;
